import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetSafetyChecklistByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getSafetyChecklistById = async (id: string) => {
  return await axiosAuth.get(`${SAFETY_CHECKLIST_API}/${id}`);
};

const useGetSafetyChecklistById = ({
  id,
  queryParams,
}: UseGetSafetyChecklistByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["safety-checklist", id],
    queryFn: () => getSafetyChecklistById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetSafetyChecklistById;
